import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function SkillsSection() {
  const skills = [
    {
      category: "AI / ML / NLP",
      items: [
        "Transformers (BERT, RoBERTa, T5)",
        "Sentence-Transformers",
        "RAG Systems",
        "LLM Integration (OpenAI, Gemini, Anthropic, Cohere)",
        "Fine-Tuning (LoRA, QLoRA)",
        "Prompt Engineering",
        "NER, Text Classification, Summarization, QA",
        "Topic Modeling",
        "Anomaly Detection",
        "Embedding Validation",
        "Hallucination Detection",
        "PyTorch, TensorFlow, Scikit-learn",
        "spaCy, NLTK",
      ],
    },
    {
      category: "Backend Development",
      items: [
        "FastAPI, Django, Flask",
        "Node.js, Express.js",
        "Spring Boot 3, Spring Security 6",
        "JPA/Hibernate",
        "REST APIs",
        "Microservices Architecture",
        "WebSockets (STOMP)",
        "Event-Driven Systems (Kafka, RabbitMQ)",
      ],
    },
    {
      category: "Frontend Development",
      items: [
        "React.js, Next.js (App Router)",
        "TypeScript, JavaScript",
        "TailwindCSS, Shadcn/UI",
        "Responsive UI",
        "Recharts Data Visualization",
      ],
    },
    {
      category: "Databases & Storage",
      items: [
        "PostgreSQL, MySQL",
        "MongoDB",
        "Redis (Caching, Queues)",
        "Cloudflare R2, Upstash Redis",
        "Prisma ORM, Hibernate",
      ],
    },
    {
      category: "Vector Databases & Search",
      items: [
        "FAISS, Pinecone, ChromaDB, Qdrant",
        "Elasticsearch (Full-Text Search)",
      ],
    },
    {
      category: "DevOps & Cloud",
      items: [
        "Docker, Kubernetes (basic)",
        "AWS (S3, EC2, RDS, SageMaker)",
        "CI/CD (GitHub Actions, Jenkins, GitLab CI)",
        "Nginx, Linux/Bash",
        "Load Testing, Observability",
        "Monitoring (Grafana)",
      ],
    },
    {
      category: "Testing & Automation",
      items: [
        "pytest, Jest, JUnit 5, Mockito",
        "TestContainers, Selenium",
        "API Testing (Postman, REST Assured)",
        "Integration & E2E Testing",
        "Automated regression testing",
        "Load testing, synthetic monitoring",
      ],
    },
    {
      category: "Data Processing & Extraction",
      items: [
        "PyMuPDF, PDFPlumber, PDFMiner, PyPDF2",
        "Tesseract OCR",
        "Selenium, BeautifulSoup, Scrapy",
        "Pandas",
        "ETL Pipelines (text/log processing)",
      ],
    },
    {
      category: "Programming Languages",
      items: [
        "Python",
        "JavaScript / TypeScript",
        "Java",
        "C++",
        "SQL",
        "Bash",
        "Go (familiar)",
      ],
    },
    {
      category: "Systems & Infrastructure",
      items: [
        "Linux/Unix CLI",
        "Distributed Systems",
        "Network Protocols (TCP/IP)",
        "Real-Time Monitoring",
        "Logging, Alerting Systems",
      ],
    },
  ];

  return (
    <Container>
      <h1 className="project-heading" style={{ paddingBottom: "20px" }}>
        Technical <strong className="purple">Skills</strong>
      </h1>
      <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
        {skills.map((skillGroup, index) => (
          <Col md={6} key={index} style={{ paddingBottom: "30px" }}>
            <div className="skill-category-card">
              <h3 className="skill-category-title">{skillGroup.category}</h3>
              <ul className="skill-list">
                {skillGroup.items.map((skill, idx) => (
                  <li key={idx} className="skill-item">
                    {skill}
                  </li>
                ))}
              </ul>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default SkillsSection;
